export default __webpack_public_path__ + "static/media/healthier.240f82ba.jpg";